export default __webpack_public_path__ + "static/media/dacheng.cd361fb0.png";